<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="alllot"/>
        <MenuStockList/>
        <LotDetailOutList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import LotDetailOutList from '@/components/menuadmin/stock/stocklist/LotDetailOutList.vue'

export default {
    name:'lotDetailOut',
    components:{
        HeaderStock,
        MenuStockList,
        LotDetailOutList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>